import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../components/MaterialButton";
import { Button, TextField } from "@mui/material";
import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import { salesTargetGetById, UpdateMonthlyTargets } from "./grphql";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoading } from "../../context/LodingContext";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";

const UpdateMonthlyTarget = () => {
  const [showData, setShowData] = useState(null);
  const [id, setId] = useState(null);
  const [originalMonths, setOriginalMonths] = useState([]);
  const [editIdx, setEditIdx] = useState(-1);
  const [totalTarget, setTotaltarget] = useState(0);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();
  const navigate = useNavigate();

  const location = useLocation();
  const pathid = location.search.slice(1);
  useEffect(() => {
    fetchData();
    setId(pathid);
  }, [pathid, id]);

  useEffect(() => {
    const finalAmount = originalMonths?.reduce((acc, cur) => {
      return acc + Number(cur?.targetAmount);
    }, 0);
   
    
    setTotaltarget(Math.round(finalAmount));
  }, [originalMonths]);
  const fetchData = async () => {
    try {
      const res = await request(BASEURL, salesTargetGetById, { id: id });      
      setShowData(res?.salesTargetGetById);
      setOriginalMonths(res?.salesTargetGetById?.monthlytargetSet);
    } catch (err) {
    } finally {
    }
  };
  const handleEdit = (index) => {
    setEditIdx(index);
  };
  const handleSave = () => {
    setEditIdx(-1);
  };
  const handleMonthlyDistbute = () => {
    const amount = showData?.targetAmount / 12;

    const setamount = originalMonths?.map((v, i) => ({
      ...v,
      targetAmount: Math.round(amount * 100) / 100,
    }));
    setOriginalMonths(setamount);    
  };
  const handleChange = (e, index, field) => {
    const updatedData = [...originalMonths];

    updatedData[index][field] = e.target.value;

    setOriginalMonths(updatedData);
  };

  const handleUpdateMonthly = async () => {
    setCirleLoading(true);
    try {
      const res = request(BASEURL, UpdateMonthlyTargets, {
        monthlyTargets: originalMonths,
      });
      setSucessTitle("Updated ");
      setSuccessStatus(true);
      setTimeout(() => {
        setSuccessStatus(false);
        navigate("/SalesTarget");
      }, 3000);
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <table className="montable">
        <thead>
          <tr className="montr">
            <th className="month">Employee Name</th>
            <th className="month">Financial Year</th>
            <th className="month">Target Amount</th>
          </tr>
        </thead>
        <tbody className="month">
          <tr className="montr">
            <td className="montd">{showData?.user?.username}</td>
            <td className="montd">{showData?.salesTarget?.financialYear}</td>
            <td className="montd">{showData?.targetAmount}</td>
          </tr>
        </tbody>
      </table>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          paddingRight: "20px",
          margin: "5px 0px",
        }}
      >
        <MaterialButton
          variant="gradient"
          color="dark"
          // disabled={totalTarget == totalamount ? false : true}
          // disabled={!checkAllFields()}
          onClick={handleMonthlyDistbute}
        >
          Distribute Evenly
        </MaterialButton>
      </div>

      <div className="tabel-target">
        <table>
          <thead>
            <tr>
              <th>S.NO</th>
              <th>Month</th>
              <th>Target Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {originalMonths?.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{row.monthYear}</td>
                  <td
                    style={{
                      display: "flex",
                      marginTop: "5px",
                      alignItems: "center",
                    }}
                  >
                    {editIdx === index ? (
                      <TextField
                        type="number"
                        value={row.targetAmount}
                        onChange={(e) => handleChange(e, index, "targetAmount")}
                      />
                    ) : (
                      row.targetAmount || 0
                    )}

                    <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
                  </td>
                  <td>
                    {editIdx === index ? (
                      <Button onClick={handleSave}>Save</Button>
                    ) : (
                      <Button onClick={() => handleEdit(index)}>Edit</Button>
                    )}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td></td>
              <td>Total Amount </td>
              <td
                style={{
                  display: "flex",
                  marginTop: "15px",
                  alignItems: "center",
                  fontWeight: "600",
                  fontSize: "18px",
                }}
              >
                {showData?.targetAmount || "0"}{" "}
                <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
              </td>
              <td>
                {" "}
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  disabled={
                    totalTarget == showData?.targetAmount ? false : true
                  }
                  onClick={handleUpdateMonthly}
                >
                  Update
                </MaterialButton>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default UpdateMonthlyTarget;
